import orderSummaryStyles from '../OrderSummary.scss';

import cx from 'classnames';
import React from 'react';
import { TextV2 } from 'src/components/TextV2/TextV2';

interface SummarySectionProps {
  heading?: string;
  subheading: string;
  price: string;
  description?: string;
}

export const SummarySection: React.FC<SummarySectionProps> = ({
  heading,
  price,
  subheading,
  description,
}) => (
  <section className={cx(orderSummaryStyles.section, orderSummaryStyles.sectionBordered)}>
    {heading && (
      <TextV2
        tagName="h4"
        variant="eyebrow"
        className={orderSummaryStyles.heading}
        value={heading}
      />
    )}
    <div className={cx(orderSummaryStyles.subheading, orderSummaryStyles.subheadingSpaced)}>
      <TextV2
        data-test="subheading"
        variant="body"
        tagName="p"
        value={subheading}
        className={orderSummaryStyles.subheadingLabel}
      />
      <TextV2
        data-test="price"
        variant="body"
        tagName="p"
        value={price}
      />
    </div>
    {description && (
      <TextV2
        tagName="p"
        variant="small"
        value={description}
        className={orderSummaryStyles.description}
      />
    )}
  </section>
);

SummarySection.displayName = 'SummarySection';
